import SideNav from "./sidenav";
import React, { useState, useEffect, Component } from "react";
import "./financial-report.css";
import Download from "../images/downloadicon.png";
import { Pagination, Table } from 'react-bootstrap';
import Mobilenav from "./mobiledropdwn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import Footer from "./footer";
import AOS from 'aos';


const client = new ApolloClient({
  link: new HttpLink({ uri: "https://pensure-cms.inspireleadership.biz/graphql"}),
  cache: new InMemoryCache(),
})

const FinancialReport = () => {



   window.scrollTo(0, 0)
   
  const [active, setActive] = useState("ALL");
  const[heroBanner, setHeroBanner] = useState([])
  const [heroMobile, setHeroMobile] = useState([])
  const [reports, setReport] = useState([])

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  // Calculate indexes for slicing data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = reports.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(reports.length / itemsPerPage);

  // Generate pagination items
  let items = [];
  for (let number = 1; number <= totalPages; number++) {
    items.push(
      <Pagination.Item 
        key={number} 
        active={number === currentPage}
        onClick={() => setCurrentPage(number)}
      >
        {number}
      </Pagination.Item>
    );
  }


function buttonCall(){ 
const target = document.getElementById('fnc-p');

target.scrollIntoView({ behavior: 'smooth' });

  }


       useEffect( () => {
                 AOS.init({
                    offset: 0,
                    duration: 1000,
                    once: true
             });
                              
                                  
             }, [])


useEffect( () => {
      
      client
        .query({
          query: gql`
        query NewQuery {
pages(first:100) {
    edges {
      node {
        report {
          hero {
            buttonLink
            buttonName
            caption
            heading
            image {
              mediaItemUrl
            }
          }
          heromobile {
            buttonLink
            buttonName
            caption
            heading
            image {
              mediaItemUrl
            }
          }
          reports {
            description
            link
            name
          }
        }
      }
    }
  }
      }
          `,
        })
        .then((result) => {
      
           console.log(result)
            setHeroBanner(result.data.pages.edges[12].node.report.hero)
            setHeroMobile(result.data.pages.edges[12].node.report.heromobile)
            setReport(result.data.pages.edges[12].node.report.reports)
      
        });
      
      }, [])  


           let heroBannerDisplay
           let heroMobileBannerDisplay
                        
                        
                              
                              
           if(heroBanner.length > 0 ){
               heroBannerDisplay = heroBanner.map((banner, i) => 
                        
                <div className="group-cover">
                <img className="group-bg" src={banner.image.mediaItemUrl}  />
                <div className="group-content">
                  <div className="group-txt">
                    <h1 className="group-h1 "  data-aos="zoom-in" data-aos-delay="200"> {banner.heading} </h1>
                    <p className="grey-p-group"  data-aos="fade-up" data-aos-delay="200">
                     {banner.caption}    </p>
                    <a className="btn-trns" id="btn-response" onClick={buttonCall}  data-aos="fade-up" data-aos-delay="200">
                      {" "}
                     {banner.buttonName} {" "}
                      <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
                    </a>
                  </div>
                </div>
              </div>
                   
           
                              
                              
                                )
                              }
                        
              if(heroMobile.length > 0 ){
               heroMobileBannerDisplay = heroMobile.map((banner, i) => 
              
                 <div className="group-cover">
                <img className="group-bg" src={banner.image.mediaItemUrl}  />
                <div className="group-content">
                  <div className="group-txt">
                    <h1 className="group-h1 "  data-aos="zoom-in" data-aos-delay="200"> {banner.heading} </h1>
                    <p className="grey-p-group"  data-aos="fade-up" data-aos-delay="200">
                     {banner.caption}    </p>
                    <a className="btn-trns" id="btn-response" onClick={buttonCall}  data-aos="fade-up" data-aos-delay="200">
                      {" "}
                     {banner.buttonName} {" "}
                      <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
                    </a>
                  </div>
                </div>
              </div>
                                              
                                )
                              }




    let reportsDisplay 

    reportsDisplay=  currentItems.map((yearlyreports, idx) => (
           <div key={idx} id="fnc-card" className=" "  data-aos="fade-up" data-aos-delay="200">
                  <div>
                    {" "}
                    <h5 className="finance-h5">
                     {yearlyreports.name} Financial Report
                    </h5>
                    <p className="finance-p">
                      {" "}
                     Full year  {yearlyreports.name} financial summary including income, expenses, investments and more
                    </p>
                  </div>
                  <a className="no-decoration dwn-btn-fnc d-flex align-items-center" href={yearlyreports.link}>
                    {" "}
                    Download {yearlyreports.name} Report{" "}
                    <img className="ms-2" src={Download} alt="Download" />
                  </a>
                </div>
   

          ))

  return (

    <>
      <div className="group-container d-none d-sm-block">
     {heroBannerDisplay}
      </div>

    <div className="group-container d-block d-sm-none">
     {heroMobileBannerDisplay}
      </div>
   
    <div
      id="payment-types-section"
      class="containeer   mt-4"
      style={{ backgroundColor: "none" }}
    >
    
    
        <div className="rght-side-fnc flex-1 p-6">
         
            <div className="payment-type-content">
              <h2 className="payment-h2" data-aos="fade-up" data-aos-delay="200">Report Archive</h2>
              <p id="fnc-p" data-aos="fade-up" data-aos-delay="200">Download our Audited report and track our yearly performance</p>

             {reportsDisplay}
            </div>
     
          <div className="paginationDivFinance mx-auto"> 

     
              <Pagination>
              {items}
               <Pagination.Next className="ps-2" onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} />
           
             </Pagination>

                  </div>
        </div>
      </div>
          <Footer/>
           <div className='height'> 

              </div>
 </>
  );
};

export default FinancialReport;
